const status = {
  200:'操作成功',
  201:'对象创建成功',
  202:'请求已经被接受',
  204:'操作已经执行成功，但是没有返回数据',
  301:'资源已被移除',
  303:'重定向',
  304:'资源没有被修改',

  400: '错误请求参数列表错误（缺少，格式不匹配）',
  401: '未授权',
  403: '访问受限，授权过期',
  404: '资源服务未找到',
  405: '方法禁用，不允许的http方法',
  406: '不接受，无法使用请求的内容特性响应请求',
  407: '需要代理授权',
  408: '请求超时',
  409: '服务器在完成请求时发生冲突或者资源被锁',
  410: '已删除',
  411: '需要有效长度',
  412: '未满足前提条件',
  413: '请求实体过大',
  414: '请求的 URI 过长',
  415: '不支持的数据，媒体类型',
  416: '请求范围不符合要求',
  417: '未满足期望值',

  500: '服务内部错误',
  501: '接口未实现',
  502: '参数验证失败',
  503: '登录失败',
  504: '网关超时',
  505: 'HTTP 版本不受支持',

}

export const find = (error_status) => {
  for (let statusKey in status) {
    if (Number(error_status) === Number(statusKey)) {
      return status[statusKey]
    }
  }
}
